import { CalendarPlus, CalendarX } from "lucide-react";
import { format, addMinutes } from "date-fns";

interface ScheduleToAdd {
  startsAt: string | Date;
  durationMinutes: number;
  scheduleType?: string | null;
}

interface ShiftToCancel {
  startsAt: string | Date;
  endsAt: string | Date;
}

export function ProposalScheduleChanges({
  schedulesToAdd,
  shiftsToCancel,
}: {
  schedulesToAdd: ScheduleToAdd[];
  shiftsToCancel: ShiftToCancel[];
}) {
  if (schedulesToAdd.length === 0 && shiftsToCancel.length === 0) {
    return null;
  }

  return (
    <div className="mt-2 space-y-1.5">
      {schedulesToAdd.length > 0 && (
        <div>
          <p className="text-xs font-medium text-emerald-700 mb-0.5">Adding</p>
          <div className="space-y-0.5">
            {schedulesToAdd.map((s) => {
              const start = new Date(s.startsAt);
              return (
                <div
                  key={start.toISOString()}
                  className="flex items-center gap-1.5 text-sm text-gray-700"
                >
                  <CalendarPlus className="h-3.5 w-3.5 text-emerald-500 shrink-0" />
                  <span>
                    {format(start, "MMM d, yyyy")}
                    {" \u00b7 "}
                    {format(start, "h:mm a")}
                    {" - "}
                    {format(addMinutes(start, s.durationMinutes), "h:mm a")}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {shiftsToCancel.length > 0 && (
        <div>
          <p className="text-xs font-medium text-rose-600 mb-0.5">Removing</p>
          <div className="space-y-0.5">
            {shiftsToCancel.map((c) => {
              const start = new Date(c.startsAt);
              return (
                <div
                  key={start.toISOString()}
                  className="flex items-center gap-1.5 text-sm text-gray-700"
                >
                  <CalendarX className="h-3.5 w-3.5 text-rose-500 shrink-0" />
                  <span>
                    {format(start, "MMM d, yyyy")}
                    {" \u00b7 "}
                    {format(start, "h:mm a")}
                    {" \u2013 "}
                    {format(new Date(c.endsAt), "h:mm a")}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
